var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconAppStore = function SvgIconAppStore(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 23,
    viewBox: "0 0 18 23",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B0B5C4",
    fillRule: "nonzero",
    d: "M15.018 11.715c-.028-2.792 2.277-4.131 2.38-4.198-1.295-1.895-3.313-2.155-4.032-2.185-1.716-.174-3.35 1.011-4.221 1.011-.87 0-2.214-.985-3.638-.96-1.871.029-3.597 1.089-4.56 2.765-1.945 3.374-.498 8.372 1.397 11.108.926 1.34 2.03 2.844 3.48 2.79 1.396-.055 1.924-.903 3.612-.903 1.688 0 2.162.903 3.64.876 1.502-.028 2.454-1.365 3.373-2.709 1.064-1.554 1.502-3.058 1.527-3.135-.033-.015-2.93-1.125-2.958-4.46zM12.242 3.52c.77-.934 1.289-2.229 1.147-3.521-1.108.045-2.452.738-3.247 1.67-.714.826-1.338 2.145-1.171 3.411 1.237.097 2.5-.629 3.27-1.56z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconAppStore, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-app-store.43b87fc7.svg";
export { ForwardRef as ReactComponent };